import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { UserProfileService } from '../../../features/users/services/user-profile.service';

@Component({
  selector: 'app-user-menu',
  template: require('./user-menu.component.html'),
  styles: [require('./user-menu.component.sass')]
})
export class UserMenuComponent implements OnInit {

    @Input() fullname: string;
    @Output() logout = new EventEmitter();
    @Output() timezoneChanged = new EventEmitter<string>();

    currentMetric: string | null;
    currentLanguage: string | null;
    currentCurrency: string | null;
    currentLocale: string | null;
    currentTimezone: string | null;

    metrics: any =  environment.systemUnits;
    languages: any =  environment.languages;
    currencies: any = environment.currencies;
    locales: any = environment.locales;
    timezones: any = environment.timezones;

    rootScope: any; 

    constructor(
      private userProfileService: UserProfileService,
      @Inject('$rootScope') $rootScope: any
    ){
      this.rootScope = $rootScope;
    }

    ngOnInit(): void {
      this.currentCurrency = this.userProfileService.getProfile('nomad.noc.ng.currency') || this.currencies.default;
      this.currentLanguage = this.userProfileService.getProfile('nomad.noc.ng.language') ||  this.languages.default;
      this.currentMetric = this.userProfileService.getProfile('nomad.noc.ng.units') || this.metrics.default;
      this.currentLocale = this.userProfileService.getProfile('nomad.noc.ng.locale') || this.locales.default;
      this.currentTimezone = this.userProfileService.getProfile('nomad.noc.ng.timezone') || this.timezones.default;
    }
  
    changeProperty = (propertyName: string, value: string) => {
      this.userProfileService.updateProfile(propertyName, value);
      switch (propertyName) {
        case 'nomad.noc.ng.language':
          this.rootScope.$broadcast('languageChanged', value);
          this.currentLanguage = this.userProfileService.getProfile('nomad.noc.ng.language');
        case 'nomad.noc.ng.language':
          this.rootScope.$broadcast('localeChanged', value);
          this.currentLocale = this.userProfileService.getProfile('nomad.noc.ng.locale');
          break;
        case 'nomad.noc.ng.timezone':
          this.rootScope.$broadcast('timeZoneChanged');
          this.timezoneChanged.emit(value);
          this.currentTimezone = this.userProfileService.getProfile('nomad.noc.ng.timezone');
          break;
        case 'nomad.noc.ng.currency':
          this.rootScope.$broadcast('currencyChanged', value);
          this.currentCurrency = this.userProfileService.getProfile('nomad.noc.ng.currency');
          break;
        case 'nomad.noc.ng.units':
          this.rootScope.$broadcast('unitsChanged', value);
          this.currentMetric = this.userProfileService.getProfile('nomad.noc.ng.units');
          break;
        default:
          break;
      }
    }

    onClearFilters = () => {
      this.changeProperty('nomad.noc.ng.timezone', this.timezones.default)
      this.changeProperty('nomad.noc.ng.units', this.metrics.default)
      this.changeProperty('nomad.noc.ng.language', this.languages.default)
      this.changeProperty('nomad.noc.ng.locale', this.locales.default)
      this.changeProperty('nomad.noc.ng.currency', this.currencies.default)
    }

    onLogout = async () => {
        this.logout.emit();
    }
}
